export type DashboardPageOptions =
  | "Schedules"
  | "Visitors"
  | "News"
  | "SiteInfo";

export const getDefaultDashboardTab = (
  isOrgPrivacyEnabled: boolean,
  isMobile?: boolean
): DashboardPageOptions => {
  return isMobile
    ? "Schedules"
    : isOrgPrivacyEnabled
      ? "SiteInfo"
      : "Schedules";
};
